import React from "react";
import { Button, Col, Container, Modal, Nav, Row, Tab } from "react-bootstrap";
import OverviewTab from "./alltabs/OverViewTab";
import AboutTab from "./alltabs/AboutTab";
import FloraTab from "./alltabs/FloraTab";
import ReachTab from "./alltabs/ReachTab";
import MapTab from "./alltabs/MapTab";
import OperatorTab from "./alltabs/OperatorTab";
import SharedTab from "./alltabs/SharedTab";
import PackageTab from "./alltabs/PackageTab";
import ReviewTab from "./alltabs/ReviewTab";

function AnimalDetail() {
  return (
    <>
      <section className="banner_section-inner packagebnner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/webp"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
          />
        </picture>
        <div className="banner_searchBox">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="headingBnner_inner">
                  <h1>Satpura Tiger Reserve</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="articals_wrapper  pt-3"
        style={{ background: "#fff" }}
      >
        <Container fluid>
          <Row className="mb-4 justify-content-center mt-4 padding_added">
            <Col lg={12} xl={10} className="safartabs position-relative">
              <div className="right_button float-lg-end pb-2 d-lg-block d-flex justify-content-end">
                <Button
                  variant="link"
                  className="btn-exclamation pe-1 writeSuggestionBtn"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal3"
                  value="/park/default/suggestion?park_id=60"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="30"
                    viewBox="0 0 512 512"
                    style={{ enableBackground: "new 0 0 512 512" }}
                    data-bs-type="info"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    data-bs-title="Submit correction if found wrong information!"
                  >
                    <g>
                      <path
                        d="M507.494 426.066 282.864 53.537a31.372 31.372 0 0 0-53.73 0L4.506 426.066a31.37 31.37 0 0 0 26.864 47.569h449.259a31.372 31.372 0 0 0 26.865-47.569zM256.167 167.227c12.901 0 23.817 7.278 23.817 20.178 0 39.363-4.631 95.929-4.631 135.292 0 10.255-11.247 14.554-19.186 14.554-10.584 0-19.516-4.3-19.516-14.554 0-39.363-4.63-95.929-4.63-135.292 0-12.9 10.584-20.178 24.146-20.178zm.331 243.791c-14.554 0-25.471-11.908-25.471-25.47 0-13.893 10.916-25.47 25.471-25.47 13.562 0 25.14 11.577 25.14 25.47 0 13.562-11.578 25.47-25.14 25.47z"
                        fill="#585757"
                        opacity="1"
                      ></path>
                    </g>
                  </svg>
                </Button>

                <Modal id="exampleModal3" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Submit Correction</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <p>Provide details about the correction.</p>
                  </Modal.Body>
                </Modal>
              </div>
              <div id="flashMessage" style={{ display: "none" }}>
                Submit correction if found wrong information!
              </div>
              <Tab.Container defaultActiveKey="overview">
                <Nav
                  className="nav nav-tabs d-block d-md-flex gap-2 align-items-baseline navtabs_design"
                  id="myTab"
                  role="tablist"
                >
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="overview" className="nav-link">
                      OVERVIEW
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="about-park" className="nav-link">
                      ABOUT PARK
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="flora-fauna" className="nav-link">
                      FLORA & FAUNA
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="how-to-reach" className="nav-link">
                      HOW TO REACH
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item role="presentation">
                    <Nav.Link eventKey="map" className="nav-link">
                      MAP
                    </Nav.Link>
                  </Nav.Item>
                  {/* <div className="btn_wrap pt-md-0 pt-3 d-lg-block d-none">
                    <a
                      href="https://forest.mponline.gov.in/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="intested_btn"
                    >
                      OFFICIAL WEBSITE
                    </a>
                  </div> */}
                </Nav>

                <Tab.Content className="">
                  <Tab.Pane eventKey="overview">
                    <OverviewTab />
                  </Tab.Pane>
                  <Tab.Pane eventKey="about-park">
                    <AboutTab />
                  </Tab.Pane>
                  <Tab.Pane eventKey="flora-fauna">
                    <FloraTab />
                  </Tab.Pane>
                  <Tab.Pane eventKey="how-to-reach">
                    <ReachTab />
                  </Tab.Pane>
                  <Tab.Pane eventKey="map">
                    <MapTab />
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>
          </Row>
        </Container>

        <Tab.Container defaultActiveKey="operators">
          <Row
            className="pt-2 itenary_tabs justify-content-center position-relative"
            id="safari_tour_operator_container"
          >
            <Col xxl={11} className="safartabs position-relative">
              <Row>
                <Col
                  xxl={10}
                  xl={9}
                  lg={8}
                  className="offset-xxl-2 offset-xl-3 offset-lg-4 mt-2 position-relative safartabs"
                >
                  <Nav
                    className="nav nav-tabs slider_addmobile3 owl-theme"
                    id="myTab"
                    role="tablist"
                  >
                    <Nav.Item role="presentation">
                      <Nav.Link eventKey="operators" className="nav-link">
                        Operators
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item role="presentation">
                      <Nav.Link eventKey="shared-safaris" className="nav-link">
                        Shared Safaris
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item role="presentation">
                      <Nav.Link eventKey="packages" className="nav-link">
                        Packages
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item role="presentation">
                      <Nav.Link eventKey="reviews" className="nav-link">
                        Reviews
                      </Nav.Link>
                    </Nav.Item>
                  </Nav>
                </Col>
              </Row>
            </Col>

            <Tab.Content className="" style={{ background: "#f5f5f5" }}>
              <Tab.Pane eventKey="operators">
                <OperatorTab />
              </Tab.Pane>
              <Tab.Pane eventKey="shared-safaris">
                <SharedTab />
              </Tab.Pane>
              <Tab.Pane eventKey="packages">
                <PackageTab />
              </Tab.Pane>
              <Tab.Pane eventKey="reviews">
                <ReviewTab />
              </Tab.Pane>
            </Tab.Content>
          </Row>
        </Tab.Container>
      </section>
    </>
  );
}

export default AnimalDetail;
